<template lang="pug">
.accordion
  button.accordion__header(:class="headerClass" @click.prevent="activate")
    span.h4(v-html="heading")
    icon(:name="currentIcon", size="24px")
  .accordion__content(v-if="active" ref="content" transition="expand")
    .accordion__inner-content
      slot
</template>

<script>
  import Icon from 'scripts/components/basic/Icon.vue';

  export default {
    name: 'Accordion',
    components: { Icon },
    props: {
      heading: {
        type: String,
        required: true,
      },
      selected: {
        type: Boolean,
        default: false,
      },
      activeIcon: {
        type: String,
        default: 'minus',
      },
      inactiveIcon: {
        type: String,
        default: 'plus',
      }
    },
    data() {
      return {
        active: true,
        scrollHeight: 0,
      };
    },
    computed: {
      headerClass() {
        return {
          'is-open': this.active,
        };
      },
      currentIcon() {
        return this.active ? this.activeIcon : this.inactiveIcon;
      },
    },
    mounted() {
      // NOTE: this has to be set to false after mount or scrollHeight will be 0
      this.active = this.selected;

      if (this.$parent.addAccordion) {
        this.$parent.addAccordion(this);
      }
    },
    beforeDestroy() {
      this.active = false;
      if (this.$parent.removeAccordion) {
        this.$parent.removeAccordion(this);
      }
    },
    methods: {
      activate() {
        if (this.$parent.activate && !this.active) {
          this.$parent.activate(this);
          this.$emit('active');
        } else {
          this.active = !this.active;
        }
      },
    },
  };
</script>

<style scoped lang="scss">
  .accordion {
    border-bottom: 1.5px solid $color-grey-600;

    &:first-child {
      border-top: 1.5px solid $color-grey-600;
    }
  }
  .accordion__header {
    background-color: transparent;
    color: var(--color-navy-500);
    padding: 24px 0;
    height: auto;
    width: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    border-radius: 0;
    border: 0;
    outline: 0;

    &:hover,
    &:active,
    &.is-open {
      color: var(--color-navy-500);
    }
  }

  .accordion__content {
    overflow: hidden;
  }

  .accordion__inner-content {
    padding: rem(15px) 0;
  }
</style>
